module.exports = __webpack_public_path__ + "img/landing_never1.dd099f98.png";